export enum CarriersName {
  GEODIS = "Geodis",
  COLISSIMO = "Colissimo",
  DHL = "DHL",
  GLS = "GLS",
  RELAISCOLIS = "Relais Colis",
  UPS = "UPS",
}
